// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.websiteInfo__container {
  font-size: var(--info-font-size);
}
.websiteInfo .agenda-card__collapsible {
  background-color: var(--agenda-card-bg-color) !important;
  border: 1px solid var(--default-border-color) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/blocks/Info/Info.scss"],"names":[],"mappings":"AAGI;EACI,gCAAA;AAFR;AAII;EACI,wDAAA;EACA,wDAAA;AAFR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
